module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1100.93eb8802.svg";